// O passo de VÁRIOS passageiros (#4103): o mesmo voo pedido para o solicitante e para
// colegas num pedido só é um card, e não o voo repetido sem nome. O agrupamento é do
// trip-document (`tripStops` → `TripStop.services`); aqui mora só o que o card desenha dele.
import type { TripStop } from './derive.js';
import { t } from './i18n.js';

/** O valor do passo: a soma dos bilhetes dele — o card de "2 passageiros" custa os dois,
 *  e o total da viagem segue o mesmo. Null quando algum bilhete não tem valor: a soma
 *  parcial mentiria o card. A moeda é uma só (o trip-document só junta bilhetes de uma). */
export function stopAmount(stop: TripStop): number | null {
  let total = 0;
  for (const service of stop.services) {
    if (service.amount == null) return null;
    total += service.amount;
  }
  return total;
}

/** O passo fala de mais de um passageiro: o que é de UM só (o código do voucher, o
 *  assento, a oferta de adicional) sai do card e fica no voucher de cada um. */
export function isPartyStop(stop: TripStop): boolean {
  return stop.services.length > 1;
}

/** Quem embarca no passo: a contagem e o nome de cada passageiro, e cada nome é a porta
 *  do voucher DAQUELE passageiro — o card inteiro abre um só. Nada na viagem de quem voa
 *  sozinho. */
export function StopParty({
  stop,
  onOpenVoucher,
}: Readonly<{ stop: TripStop; onOpenVoucher: (serviceKey: string) => void }>) {
  if (!isPartyStop(stop)) return null;
  return (
    <span className="tp-stop__pax">
      <span className="tp-stop__paxk">
        {t('trips.panel.travelers', { count: stop.services.length })}
      </span>
      {stop.services.map((service) => {
        const name = service.voucher.traveler?.name ?? service.voucherCode ?? '—';
        return (
          <button
            key={service.key}
            type="button"
            className="tp-stop__paxname"
            aria-label={t('trips.panel.openTravelerVoucher', { name })}
            onClick={() => {
              onOpenVoucher(service.key);
            }}
          >
            {name}
          </button>
        );
      })}
    </span>
  );
}
